import { Outlet, Navigate, createRootRouteWithContext, HeadContent } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { Toaster } from '@/components/ui/sonner'

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component:  OutletPath,
    notFoundComponent: NotFoundRoute,
})

const SITE_LD_JSON = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'LodgingBusiness',
    name: 'Tempula Homestay',
    description: 'Elegant private rooms in Siliguri, West Bengal. WiFi, pool, free parking and homely comfort.',
    url: 'https://tempulahomestay.com',
    telephone: '',
    address: {
        '@type': 'PostalAddress',
        addressLocality: 'Siliguri',
        addressRegion: 'West Bengal',
        postalCode: '734001',
        addressCountry: 'IN',
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 26.7271,
        longitude: 88.3953,
    },
    priceRange: '₹₹',
    currenciesAccepted: 'INR',
    paymentAccepted: 'Cash, Credit Card, UPI',
    amenityFeature: [
        { '@type': 'LocationFeatureSpecification', name: 'WiFi', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Swimming Pool', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Free Parking', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Kitchen', value: true },
    ],
})


function NotFoundRoute() {
    return <Navigate to="/tempula/home" replace />
}


function OutletPath() {
    return <>
        <HeadContent />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: SITE_LD_JSON }} />
        <Outlet />
        <Toaster richColors position="top-right" />
        <TanStackDevtools config={{ position: 'bottom-right', }}
            plugins={[{ name: 'Tanstack Router', render: <TanStackRouterDevtoolsPanel />, },]}
        />
    </>;
}
